import { z } from 'zod';
import { scoringConfigSchema } from './scoring.js';
import { questionInputSchema } from './questions.js';

/** Anlegen/Bearbeiten der Quiz-Metadaten. */
export const quizInputSchema = z.object({
  title: z.string().trim().min(1, 'Titel erforderlich').max(200),
  description: z.string().max(2000).default(''),
  themeId: z.string().max(60).default('default'),
  themeOverrides: z.record(z.string(), z.string()).nullish(),
  folderId: z.string().uuid().nullish(),
  scoringConfig: scoringConfigSchema.default({}),
  tags: z.array(z.string().trim().min(1).max(60)).max(20).default([]),
});
export type QuizInput = z.infer<typeof quizInputSchema>;

/**
 * Portables Import-/Export-Format eines einzelnen Quiz (JSON).
 * Bewusst ohne interne IDs/Zeitstempel, damit es zwischen Instanzen übertragbar
 * und versionierbar ist. `formatVersion` erlaubt spätere Migrationen.
 */
export const quizBundleSchema = z.object({
  formatVersion: z.literal(1),
  quiz: z.object({
    title: z.string().trim().min(1).max(200),
    description: z.string().max(2000).default(''),
    themeId: z.string().max(60).default('default'),
    themeOverrides: z.record(z.string(), z.string()).nullish(),
    scoringConfig: scoringConfigSchema.default({}),
    tags: z.array(z.string().trim().min(1).max(60)).default([]),
  }),
  questions: z.array(questionInputSchema),
});
export type QuizBundle = z.infer<typeof quizBundleSchema>;

export const CURRENT_BUNDLE_VERSION = 1 as const;
